import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

type EnvelopeDetailsProgressCardProps = {
  completedSigners: number;
  totalSigners: number;
  progressPercentage: number;
};

const EnvelopeDetailsProgressCard: FC<EnvelopeDetailsProgressCardProps> = ({
  completedSigners,
  totalSigners,
  progressPercentage,
}) => {
  const { t } = useTranslate();

  return (
    <div className="card rounded-xl">
      <div className="card-inner">
        <h6 className="card-title mb-3">{t('Signing Progress')}</h6>
        <div className="space-y-2">
          <div className="d-flex justify-content-between text-sm">
            <span>{t('Completed')}</span>
            <span>
              {completedSigners}/{totalSigners}
            </span>
          </div>
          <div className="progress" style={{ height: '8px' }}>
            <div
              className="progress-bar bg-success"
              style={{ width: `${progressPercentage}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnvelopeDetailsProgressCard;
